// import { lithe } from '@wheelbox/lithejs-router';
import { LitheFC } from '@wheelbox/lithejs-engine';
import { createLitheRouter, lithe } from '@wheelbox/lithejs-router';
import { configureTranslations } from '@wheelbox/lithejs-i18n';

import AppHeader from './components/app/app-header/app-header';
import AppFooter from './components/app/app-footer/app-footer';
import AppModal from './components/app/app-modal';

import { routes } from './routes';
import { withSlice, subscribe } from './state';

import en from '../messages/en.json';
import pl from '../messages/pl.json';

import {
  APP_CONTAINER_ID,
  APP_GLOBAL_SLICE,
  APP_LANGAUGE_STORAGE_KEY,
  APP_MODAL_ID,
  APP_MODAL_SLICE,
} from './constants/app';

import { GlobalSlice } from './state/index.model';

type AppProps = { id?: string; testId?: string };

configureTranslations({
  messages: {
    en,
    pl,
  },
  language: 'en',
  app: APP_CONTAINER_ID,
  storageKey: APP_LANGAUGE_STORAGE_KEY,
});

const App: LitheFC<AppProps> = ({
  id = APP_CONTAINER_ID,
  testId = 'lithe-app',
}) => {
  createLitheRouter({ routes, appId: APP_CONTAINER_ID });

  const state = withSlice(APP_GLOBAL_SLICE) as GlobalSlice;

  const onMountHandler = () => {
    subscribe(APP_GLOBAL_SLICE, id);
  };

  return () => [
    'body',
    {
      id,
      'data-testid': testId,
      class: [
        'w-screen md:w-[80vw] md:h-screen md:mx-auto p-0',
        state.theme === 'dark'
          ? 'text-[var(--color-dark-text)] bg-[var(--color-dark-background)]'
          : 'text-[var(--color-text)] bg-[var(--color-background)]',
      ],
      onmount: onMountHandler,
    },
    AppHeader({ id: 'app-header' }),
    lithe(),
    AppFooter({ id: 'app-footer' }),
    () => AppModal({ id: APP_MODAL_ID, slice: APP_MODAL_SLICE }),
  ];
};

export default App;
